<template>
  <GobSection id="impacto">
    <div class="max-w-3xl">
      <h2 class="text-gob-5 leading-tight font-extrabold tracking-gob-tighter text-balance text-main">
        Cuando la información llega a tiempo, cambia el trabajo de todos.
      </h2>
      <p class="mt-4 text-gob-2 leading-relaxed text-[#495057]">
        Gob 24/7 está pensado para quien gobierna, para quien hace posible cada programa y para quien lo recibe.
      </p>
    </div>

    <ul class="mt-12 grid gap-12 md:grid-cols-3 md:gap-8" role="list">
      <li v-for="rol in roles" :key="rol.titulo" class="flex flex-col">
        <img
          :src="rol.imagen"
          :alt="rol.alt"
          class="aspect-4/3 w-full rounded-gob-lg object-cover"
          width="1280"
          height="720"
          loading="lazy"
          decoding="async"
        />
        <h3 class="mt-6 flex items-center gap-3 text-gob-3 leading-tight font-extrabold tracking-gob-tight text-main">
          <span class="grid size-10 shrink-0 place-items-center rounded-gob-md [&_svg]:size-5" :class="rol.claseIcono">
            <component :is="rol.icono" aria-hidden="true" />
          </span>
          {{ rol.titulo }}
        </h3>
        <p class="mt-3 leading-relaxed text-[#495057]">{{ rol.texto }}</p>
        <ul class="mt-5 grid gap-2.5 border-t border-[#DEE2E6] pt-5" role="list">
          <li v-for="item in rol.items" :key="item" class="flex items-start gap-2.5 text-main">
            <IconCheck class="mt-1 size-4 shrink-0" :class="rol.claseCheck" aria-hidden="true" />
            <span>{{ item }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </GobSection>
</template>

<script>
import { IconBriefcase, IconBuildingBank, IconCheck, IconUsersGroup } from '@tabler/icons-vue'
import GobSection from '@/components/GobSection.vue'
import imagenCiudadania from '@/assets/home/ciudadano.webp'
import imagenFuncionario from '@/assets/home/funcionario.webp'
import imagenGobernante from '@/assets/home/gobernante.webp'

/*
 * Cada párrafo reúne dolor y resultado en 20 palabras o menos.
 * El ícono va por nombre registrado, no como objeto, para no volverlo reactivo.
 */
const ROLES = [
  {
    titulo: 'Para el Gobernante',
    texto: 'Sin cifras claras, rendir cuentas desgasta. El mapa de intervención social muestra dónde llega la inversión y qué logra.',
    items: ['Visibilidad total de su gestión', 'Impacto tangible en las comunidades', 'Liderazgo respaldado por datos reales'],
    icono: 'IconBuildingBank',
    claseIcono: 'bg-primary/10 text-primary',
    claseCheck: 'text-primary',
    imagen: imagenGobernante,
    alt: 'Sede del Concejo de Santiago de Cali'
  },
  {
    titulo: 'Para el Funcionario',
    texto: 'Menos horas repitiendo reportes y persiguiendo evidencias: Gob 24/7 centraliza la información y hace el seguimiento por usted.',
    items: ['Control de la gestión a un clic', 'Menos errores y cuellos de botella', 'Adiós a los reprocesos'],
    icono: 'IconBriefcase',
    claseIcono: 'bg-signal-data/10 text-signal-data',
    claseCheck: 'text-signal-data',
    imagen: imagenFuncionario,
    alt: 'Persona revisando un tablero de Gob 24/7 en su portátil'
  },
  {
    titulo: 'Para la Ciudadanía',
    texto: 'Que la atención no llegue tarde: servicios sociales personalizados según cada hogar, priorizando a quien tiene mayor vulnerabilidad.',
    items: ['Reducción del Índice de Vulnerabilidad', 'Mejor calidad de vida', 'Mayor confianza en el gobierno'],
    icono: 'IconUsersGroup',
    claseIcono: 'bg-signal-human/10 text-signal-human',
    claseCheck: 'text-signal-human',
    imagen: imagenCiudadania,
    alt: 'Ciudadanos llegando a la Oficina de Atención al Ciudadano'
  }
]

/**
 * HomeDimensiones
 * Impacto en tres dimensiones: el título de cada columna es el rol, seguido de un párrafo y sus beneficios.
 */
export default {
  name: 'HomeDimensiones',
  components: {
    GobSection,
    IconBriefcase,
    IconBuildingBank,
    IconCheck,
    IconUsersGroup
  },
  data() {
    return { roles: ROLES }
  }
}
</script>
